import gql from 'graphql-tag'
import { GQL_USER_DEFAULT_FIELDS } from '@/components/users/graphql/graphql.const.ts'

export const GetCurrentUserInfo = gql`
  query GetCurrentUserInfo {
    user: getCurrentUserInfo  {
      id
      roleId
      username
      firstname
      lastname
    }
  }
`

// Maybe return projects in sub-field?
export const GetCurrentUserInfoAndProjects = gql`
  query GetCurrentUserInfoAndProjects {
    user: getCurrentUserInfo  {
      id
      roleId
      username
      firstname
      lastname
    }
    projects: findProjects {
      id
      title
      key
    }
  }
`

/*
  id: Uint!
  roleId: Uint!
  username: String!
  firstname: String!
  lastname: String!
  contactEmail: String!
  contactPhone: String!
  companyName: String!
  lastLoginAt: String
  createdBy: ProjectChangedByUser!
  updatedBy: ProjectChangedByUser
  restrictedBy: ProjectChangedByUser
  projects: [UserProject]
 */

export const FindUsersQuery = gql`
  query FindUsers {
      users: findUsers {
        ${GQL_USER_DEFAULT_FIELDS}
      }
    }
  `

export const FindUsersCompactQuery = gql`
 query FindUsersCompactQuery  {
    users: findUsers {
      id
      firstname
      lastname
      username
    }
  }
`

export const FindUsersAndRolesQuery = gql`
  query FindUserAndRoles ($input: FindUsersInput) {
    users: findUsers(input: $input)  {
      id
      roleId
      username
      firstname
      lastname
      contactEmail
      contactPhone
      companyName
      preferredLanguage
      projects {
        id
        title
        archived
        paused
      }
    }
    userRoles: getUserRoles {
      id
      title
    }
  }`


export const GetUserRoles = gql`
  query FindUserRoles {
    userRoles: getUserRoles {
      id
      title
    }
  }`
